import { render, staticRenderFns } from "./coreActivity.vue?vue&type=template&id=065c0202&scoped=true"
import script from "./coreActivity.vue?vue&type=script&lang=js"
export * from "./coreActivity.vue?vue&type=script&lang=js"
import style0 from "./coreActivity.vue?vue&type=style&index=0&id=065c0202&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065c0202",
  null
  
)

export default component.exports